import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FireDispatchDetailsReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/fire-dispatch-details.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FireDispatchDetailsReducer, defaultState, asyncActions);
};

type IFireDispatchDetailsContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FireDispatchDetailsContext = createContext<
  Partial<IFireDispatchDetailsContext>
>({
  state: defaultState,
}) as React.Context<IFireDispatchDetailsContext>;

const FireDispatchDetailsProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FireDispatchDetailsContext.Provider value={{ ...reducer }}>
      {children}
    </FireDispatchDetailsContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFireDispatchDetailsContext = () =>
  useContext(FireDispatchDetailsContext);

export type IUseFireDispatchDetailsContext = ReturnType<
  typeof useFireDispatchDetailsContext
>;

export { FireDispatchDetailsContext, FireDispatchDetailsProvider };
